import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface CashBoxIncidentRow {
  id: string;
  plateNumber: string;
  incidentType: number;
  status: number;
  eventTimestamp: string;
  estimatedAmount: number;
  isPostClosure: boolean;
}

export interface CashBoxOpening {
  id: string;
  cashBoxId: string;
  cashBoxDescription: string; // El backend devuelve cashBoxDescription, no cashBoxName
  userId: string;
  userName?: string | null;
  openingDate: string; // El backend devuelve openingDate, no openedAt
  initialAmount: number;
  status: number; // El backend devuelve status como número (0 = Abierta)
  statusDescription?: string;
  notes?: string | null;
  closing?: any;
  movements?: any;
  currentBalance?: number;
  incidents?: CashBoxIncidentRow[];
  incidentCount?: number;
  incidentsEstimatedTotal?: number;
}

export interface CashBox {
  id: string;
  name: string;
  description?: string;
  isActive: boolean;
}

export interface ApiResponse<T> {
  success: boolean;
  requestResult?: T;
  /** @deprecated Usar requestResult. body se eliminó del JSON de la API */
  body?: T;
  message?: string;
  errors?: any[];
}

@Injectable({
  providedIn: 'root'
})
export class CashBoxService {
  private apiUrl = `${environment.apiBaseUrl}/api/v1/CashBoxes`;
  private managementUrl = `${environment.apiBaseUrl}/api/v1/cashbox-management`;

  constructor(private http: HttpClient) { }

  getAllCashBoxes(): Observable<ApiResponse<CashBox[]>> {
    return this.http.get<ApiResponse<CashBox[]>>(this.apiUrl);
  }

  getCashBoxById(id: string): Observable<ApiResponse<CashBox>> {
    return this.http.get<ApiResponse<CashBox>>(`${this.apiUrl}/${id}`);
  }

  getOpenCashBoxes(): Observable<ApiResponse<CashBoxOpening[]>> {
    return this.http.get<ApiResponse<CashBoxOpening[]>>(`${this.managementUrl}/openings/open`);
  }

  getCashBoxOpeningById(id: string): Observable<ApiResponse<CashBoxOpening>> {
    return this.http.get<ApiResponse<CashBoxOpening>>(`${this.managementUrl}/openings/${id}`);
  }

  openCashBox(cashBoxId: string, initialAmount: number): Observable<ApiResponse<CashBoxOpening>> {
    return this.http.post<ApiResponse<CashBoxOpening>>(`${this.managementUrl}/openings`, { cashBoxId, initialAmount });
  }

  closeCashBox(openingId: string, finalAmount: number, notes?: string): Observable<ApiResponse<void>> {
    return this.http.post<ApiResponse<void>>(`${this.managementUrl}/closings`, { openingId, declaredAmount: finalAmount, notes });
  }
}
